<div class="section">
    <div class="nova__label">DEA</div>
    <div data-qa-id="an_rjd_locums_dea_readonly">
        {{ otherRequirement?.isRequired ? 'Required' : '-' }}
    </div>   
</div>